export default __webpack_public_path__ + "static/media/cc-agent-1.68e70e29.webp";